import { IGerarOrdemCompraColetaPrecoUseCase } from "../../../presentation/useCases/create/gerar_ordem_compra_coleta_preco_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GerarOrdemCompraColetaPrecoUseCase
 */

export class GerarOrdemCompraColetaPrecoUseCase implements IGerarOrdemCompraColetaPrecoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async gerarOrdemCompraColetaPreco(
    idColetaPreco: number,
  ): Promise<void> {
    await this.repository.gerarOrdemCompraColetaPreco(
      idColetaPreco,
    );
  }
}
